<template>
    <div class="order_content__info">
        <div class="order_content__info_general">
            {{ generalInfo }}
        </div>
        <div v-if="isAdvancedComment" class="order_content__info_comment">
            {{ advancedComment }}
        </div>

        <div class="order_content_separator"/>

        <div class="order_content__info_list">
            <order_content_info_item
                v-for="item in products"
                :key="'order_content_info_item_' + item.id"
                :item="item"
                :isTotal="true"
                :currencyUser="currencyUser"
            />
        </div>
        <div class="order_content_separator"/>
        <div class="order_content__info_list">
            <div class="order_content__info_list no_margin">
                <order_content_info_item_props
                    v-if="isSumFull"
                    :key="'order_content_info_item_sum_full'"
                    :isTotal="false"
                    :note="''"
                    :nameItem="`${this.__t('O.FULL_PRICE')}`"
                    :discountPercent="''"
                    :discountSum="''"
                    :sumItem="sumFull"
                />
                <order_content_info_item_props
                    v-if="isSumDiscount"
                    :key="'order_content_info_item_sum_discount'"
                    :isTotal="false"
                    :note="''"
                    :nameItem="`${this.__t('O.DISCOUNT')}`"
                    :discountPercent="''"
                    :discountSum="''"
                    :sumItem="sumDiscount"
                />
                <order_content_info_item_props
                    v-if="isSumDelivery"
                    :key="'order_content_info_item_sum_delivery'"
                    :isTotal="false"
                    :note="''"
                    :nameItem="`${this.__t('O.DELIVERY')}`"
                    :discountPercent="''"
                    :discountSum="''"
                    :sumItem="sumDelivery"
                />
            </div>
            <order_content_info_item_props
                v-if="isSumWithDiscount"
                :key="'order_content_info_item_sum_with_discount'"
                :isTotal="true"
                :note="''"
                :nameItem="`${this.__t('O.TOTAL_SUM')}`"
                :discountPercent="''"
                :discountSum="''"
                :sumItem="sumWithDiscount"
            />

        </div>
    </div>
</template>

<script>
import order_content_info_item from "./OrderContentInfoItem.vue";
import order_content_info_item_props from "./OrderContentInfoItemProps.vue";
import {createHelpers} from "vuex-map-fields";
import formatNumber from "../../../mixins/formatNumber";
const {mapFields: mUser} = createHelpers({
    getterType: 'user/getUserField',
    mutationType: 'user/updateUserField',
})

const {mapFields: mOrders} = createHelpers({
    getterType: 'orders/getOrdersField',
    mutationType: 'orders/updateOrdersField',
})

export default {
    name: "order_content_info",
    props: {
        typeInfo: {
            type: String,
            required: true,
        }
    },
    emits: [],
    components: {
        order_content_info_item,
        order_content_info_item_props,
    },
    mixins: [formatNumber],
    data() {
        return {}
    },
    methods: {},
    computed: {
        ...mUser([
            'user',
        ]),
        ...mOrders([
            'activeOrderFullInfo'
        ]),
        currencyUser() {
            if (this.user && this.user.currency_suffix) {
                return this.user.currency_suffix;
            }
            return '';
        },
        generalInfo() {
            let generalInfo = '';
            if (this.activeOrderFullInfo && this.activeOrderFullInfo.pos_restaurant && this.activeOrderFullInfo.pos_restaurant.title) {
                generalInfo += this.activeOrderFullInfo.pos_restaurant.title;
            }
            if (this.activeOrderFullInfo && this.activeOrderFullInfo.pos_restaurant && this.activeOrderFullInfo.pos_restaurant.address) {
                if (generalInfo !== '') {
                    generalInfo += ' | '
                }
                generalInfo += this.activeOrderFullInfo.pos_restaurant.address;
            }
            if (this.activeOrderFullInfo && this.activeOrderFullInfo.pos_restaurant && this.activeOrderFullInfo.pos_restaurant.address) {
                if (generalInfo !== '') {
                    generalInfo += ' | '
                }
                generalInfo += this.activeOrderFullInfo.pos_restaurant.address;
            }
            if (this.activeOrderFullInfo && this.activeOrderFullInfo.aggregator && this.activeOrderFullInfo.pickup_code) {
                if (generalInfo !== '') {
                    generalInfo += ' | '
                }
                generalInfo += this.activeOrderFullInfo.aggregator + ':' + this.activeOrderFullInfo.pickup_code;
            }
            if (this.activeOrderFullInfo && this.activeOrderFullInfo.cost && this.activeOrderFullInfo.cost.subtotal) {
                if (generalInfo !== '') {
                    generalInfo += ' '
                }
                generalInfo += 'Price:' + this.activeOrderFullInfo.cost.subtotal.toString();
            }
            // if(this.activeOrderFullInfo.cost && this.activeOrderFullInfo.cost.subtotal){
            //     if(generalInfo!==''){
            //         generalInfo+=' '
            //     }
            //generalInfo += 'CODE: ????';
            // }
            // if(this.activeOrderFullInfo.cost && this.activeOrderFullInfo.cost.subtotal){
            //     if(generalInfo!==''){
            //         generalInfo+=' '
            //     }
            //generalInfo += 'ONLINE_PAY ??? без приборів ';
            // }
            if (this.activeOrderFullInfo && this.activeOrderFullInfo.cost && this.activeOrderFullInfo.cost.discount) {
                if (generalInfo !== '') {
                    generalInfo += ' '
                }
                generalInfo += 'DISCOUNT:' + this.activeOrderFullInfo.cost.discount.toString();
            }
            return generalInfo
        },
        activeOrderId() {
            if (this.activeOrderFullInfo && this.activeOrderFullInfo.id) {
                return this.activeOrderFullInfo.id;
            }
            return '';
        },
        products() {
            if (this.activeOrderFullInfo && this.activeOrderFullInfo.products && Array.isArray(this.activeOrderFullInfo.products)) {
                return this.activeOrderFullInfo.products;
            }
            return [];
        },
        sumFull() {
            if (this.activeOrderFullInfo && this.activeOrderFullInfo.cost && this.activeOrderFullInfo.cost.total !== 0 && this.user.locale) {
                return this.toCurrency(this.activeOrderFullInfo.cost.total, this.currencyUser, 'uk-UA', 2);
            }
            return '';
        },
        sumDiscount() {
            if (this.activeOrderFullInfo && this.activeOrderFullInfo.cost && this.activeOrderFullInfo.cost.discount && this.activeOrderFullInfo.cost.discount !== 0 && this.user.locale) {
                return this.toCurrency(this.activeOrderFullInfo.cost.discount, this.currencyUser, 'uk-UA', 2);
            }
            return '';
        },
        sumDelivery() {
            if (this.activeOrderFullInfo && this.activeOrderFullInfo.cost && this.activeOrderFullInfo.cost.delivery && this.activeOrderFullInfo.cost.delivery !== 0 && this.user.locale) {
                return this.toCurrency(this.activeOrderFullInfo.cost.delivery, this.currencyUser, 'uk-UA', 2);
            }
            return '';
        },
        sumWithDiscount() {
            if (this.activeOrderFullInfo && this.activeOrderFullInfo.cost && this.activeOrderFullInfo.cost.subtotal && this.activeOrderFullInfo.cost.subtotal !== 0 && this.user.locale) {
                return this.toCurrency(this.activeOrderFullInfo.cost.subtotal, this.currencyUser, 'uk-UA', 2);
            }
            return '';
        },
        isSumFull() {
            if (this.sumFull !== '') {
                return true;
            }
            return false;
        },
        isSumDiscount() {
            if (this.sumDiscount !== '') {
                return true;
            }
            return false;
        },
        isSumDelivery() {
            if (this.sumDelivery !== '') {
                return true;
            }
            return false;
        },
        isSumWithDiscount() {
            if (this.sumWithDiscount !== '') {
                return true;
            }
            return false;
        },
        isAdvancedComment() {
            if(this.activeOrderFullInfo && this.activeOrderFullInfo.advanced_comment && this.activeOrderFullInfo.advanced_comment !== ''){
                return true;
            }
            return false;
        },
        advancedComment() {
            if(this.activeOrderFullInfo && this.activeOrderFullInfo.advanced_comment && this.activeOrderFullInfo.advanced_comment !== ''){
                return this.activeOrderFullInfo.advanced_comment;
            }
            return '';


        }
    },
}
</script>
